module.exports = __webpack_public_path__ + "img/19-min.4b6eee52.jpg";